<template>
  <!-- Mobile sticky footer -->
  <div class="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 bg-white px-2 py-2.5">
    <div class="flex gap-2">
      <button
        type="button"
        class="h-11 flex-1 rounded-md bg-gray-900 px-4 text-sm !font-semibold !text-white"
        data-testid="mobile-upload-image-btn"
        @click="onUploadImageClick"
      >
        Upload Image
      </button>
      <template v-if="isUserSignedIn">
        <button
          type="button"
          class="h-11 flex-1 rounded-md border border-black bg-white px-4 text-sm !font-semibold !text-black"
          data-testid="mobile-design-library-btn"
          @click="onArtworkHistoryClick"
        >
          Design Library
        </button>
        <div
          v-if="shouldShowCanvaButton"
          class="flex h-11 flex-1 items-center justify-center rounded-md border border-black bg-white px-4 text-sm !font-semibold !text-black"
          data-testid="mobile-canva-btn"
        >
          <CanvaButton :file-landing="fileLanding" :namespace="namespace" @click="onCanvaClick" />
        </div>
      </template>
      <template v-else>
        <a
          href="/login"
          class="flex h-11 flex-1 items-center justify-center rounded-md border border-black bg-white px-4 text-sm !font-semibold !text-black no-underline"
          data-testid="mobile-login-btn"
          @click="onLoginSignupClick"
        >
          Log In / Sign Up
        </a>
      </template>
    </div>
    <div v-if="!isUserSignedIn && canvaDtfEnabled" class="mt-2 text-center">
      <span class="flex items-center justify-center gap-1 text-sm font-normal !text-black">
        Log in to access your
        <div class="brightness-0 saturate-100 filter">
          <UseSvg icon="canva" :width="46" :height="15" />
        </div>
        workspace.
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { track as rudderstackTrack } from "common/utils/rudderstack/tracker";
import UseSvg from "common/vue/components/UseSvg.vue";
import CanvaButton from "components/jiffy/canva-button/CanvaButton.vue";

const props = defineProps({
  isUserSignedIn: {
    type: Boolean,
    default: false
  },
  canvaDtfEnabled: {
    type: Boolean,
    required: true
  },
  fileLanding: {
    type: String,
    required: true
  },
  namespace: {
    type: String,
    required: true
  }
});

const emit = defineEmits(["upload-image-click", "artwork-history-click"]);

const shouldShowCanvaButton = computed(() => props.canvaDtfEnabled && props.isUserSignedIn);

const trackStickyCtaInteraction = buttonType => {
  const commonProperties = {
    button_type: buttonType,
    user_authenticated: props.isUserSignedIn,
    page_type: "pdp",
    device_type: "mobile"
  };

  submitDtfEvent("sticky_cta_interaction", commonProperties);
  rudderstackTrack("Mobile CTA Button Clicked", commonProperties);
};

const onUploadImageClick = () => {
  trackStickyCtaInteraction("upload_image");
  emit("upload-image-click");
};

const onArtworkHistoryClick = () => {
  trackStickyCtaInteraction("design_library");
  emit("artwork-history-click");
};

const onLoginSignupClick = () => {
  trackStickyCtaInteraction("login_signup");
};

const onCanvaClick = () => {
  trackStickyCtaInteraction("canva");
};
</script>
